import React from "react";
import { Helmet } from "react-helmet-async";
import "./Artstudio.css";

function Artstudio() {
  const sections = [
    {
      title: "Art Studio Lia",
      details: [
        "At Lia Lab, we believe that art is at the heart of everything we do. Our vision is to create not just NFTs, but dynamic, immersive experiences that captivate and engage. To achieve this, we’ve assembled a talented team of artists, animators, and 3D experts who work together to craft the unique visual identity of the Lia Collection."
      ]
    },
    {
      title: "3D & Animated Art",
      details: [
        "Our art is fully 3D and animated, designed to stand out in the NFT space with exceptional detail, creativity, and motion. Each piece in the Lia Collection is a work of art, carefully crafted to bring characters and environments to life. The combination of high-quality animation and stunning 3D models ensures that our NFTs are not just static images but living, breathing assets that reflect the future of digital ownership."
      ]
    },
    {
      title: "A Collaborative Effort",
      details: [
        "The creation of our art is a collaborative effort, with different specialists focusing on key aspects to ensure the highest quality.",
        "• Animators: Our talented animators are responsible for breathing life into each character and element. With their expertise in motion, they create fluid, expressive animations that add depth and personality to the NFTs.",
        "• Stage Designers: The stage designers work on crafting the perfect environments for our animated characters, enhancing their presence and making the world of Lia Lab feel alive. Every background, prop, and interactive element is meticulously crafted to elevate the overall experience.",
        "• 3D Artists: Our 3D artists create the base models for the characters and assets. They focus on the fine details, ensuring that each design is precise, immersive, and true to the vision of Lia Lab. The 3D models are rendered in a way that maximizes their visual impact, bringing them into the digital space with realism and flair."
      ]
    },
    {
      title: "Our Art Studio",
      details: [
        "The creation of Lia Lab’s art is handled by our in-house art studio, where innovation meets expertise. Our artists are not just creators—they are pioneers, pushing the boundaries of what’s possible in digital art. With their combined skills and passion, they are dedicated to making each NFT in the collection an exclusive and remarkable piece of art.",
        "We’re not just building assets; we’re crafting an experience. Lia Lab’s visual identity is built to connect with users on a deeper level, ensuring that each NFT feels special and timeless."
      ]
    }
  ];

  return (
    <>
      <Helmet>
        <title>Lia | Art Studio</title>
        <link rel="canonical" href="https://www.tilitnft.com/art-studio" />
        <meta name="description" content="The Art Studio of Lialab NFT Project" />
      </Helmet>
      <div className="art-studio-container">
        <div className="art-studio-header">
          <h1 className="art-studio-title">
            <span className="art-studio-title-span">Art Studio</span> (Lia)
          </h1>
        </div>
        <div className="art-studio-content">
          <div className="art-studio-sections">
            {sections.map((section, index) => (
              <div key={index} className="art-studio-section">
                <div className="art-studio-phase-header">
                  <h1 className="art-studio-phase-title">{section.title}</h1>
                </div>
                <div className="art-studio-phase-details">
                  {section.details.map((detail, detailIndex) => (
                    <React.Fragment key={detailIndex}>
                      {typeof detail === "string" ? (
                        <p className="section-detail" dangerouslySetInnerHTML={{ __html: detail }} />
                      ) : (
                        <p className="section-detail" dangerouslySetInnerHTML={{ __html: detail }} />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(Artstudio);